import { Checkbox } from '@shared/ui/checkbox/checkbox';
import { COLORS } from '@shared/config/colors/colors';
import { baseShadowStyle } from '@shared/style/base-shadow';
import { styled } from 'goober';

export const Body = styled('form')`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const StyledCheckbox = styled(Checkbox)`
    margin-top: 8px;
`;

export const GroupInputs = styled('div')`
    display: flex;
    gap: 16px;
`;

export const InfoWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    padding: 20px;
    justify-content: space-between;
    gap: 20px;
    border-radius: 20px;
    background-color: ${COLORS.neutral_00};
    ${baseShadowStyle}
`;

export const ButtonsWrapper = styled('div')`
    width: fit-content;
    display: flex;
    padding: 12px;
    justify-content: space-between;
    gap: 12px;
    border-radius: 20px;
    background-color: ${COLORS.neutral_00};
    ${baseShadowStyle}
`;
